import { render, staticRenderFns } from "./LicenseRecoveryView.vue?vue&type=template&id=5291ba5b"
import script from "./LicenseRecoveryView.vue?vue&type=script&lang=js"
export * from "./LicenseRecoveryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports